module.exports = __webpack_public_path__ + "img/Group-menu.88c805c8.svg";